var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('HeaderBottom',{staticClass:"ts-bg-white ts-border-b ts-border-gray-200"})],1),_c('router-view'),_c('footer',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }